import { useState } from "react";
import plusFill from "@iconify/icons-eva/plus-fill";
import { Icon } from "@iconify/react";
// material
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  InputLabel,
  FormControl,
  Select,
  MenuItem,
  TableContainer,
  TableCell,
  TableBody,
  Paper,
  TableRow,
  Table,
  TableHead,
} from "@material-ui/core";
import { useDispatch } from "react-redux";
import { useSnackbar } from "src/components/snackbar";
import { ajustesApi } from "src/services/ajustesApi";
import { clientesApi } from "src/services/clientesApi";

export default function AgregarElementoBaseCliente(props) {
  const { open, setOpen, columnasCliente } = props;
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const [nombreColumna, setNombreColumna] = useState("");
  const [tipoDato, setTipoDato] = useState("");
  const [labelComponente, setLabelComponente] = useState("");
  const [tipoComponente, setTipoComponente] = useState("");

  const [componentesAsociados, setComponentesAsociados] = useState([]);
  const [openAgregarElemento, setOpenAgregarElemento] = useState(false);
  const [elementoSelector, setElementoSelector] = useState("");
  const [addRelacionColumnaCliente] =
    ajustesApi.useAddRelacionColumnaClienteMutation();
  const [addRelacionSelectorElemento] =
    ajustesApi.useAddRelacionSelectorElementoMutation();

  const handleChangeNombreColumna = (event) => {
    setNombreColumna(event.target.value);
  };

  const handleChangeLabelComponente = (event) => {
    setLabelComponente(event.target.value);
  };

  const handleChangeTipoComponente = (event) => {
    setTipoComponente(event.target.value);
  };

  const handleChangeTipoDato = (event) => {
    setTipoDato(event.target.value);
  };

  const handleClickOpenAgregar = () => {
    setOpenAgregarElemento(true);
  };

  const handleChangeNombreElementoSelector = (event) => {
    setElementoSelector(event.target.value);
  };

  const handleCloseAgregar = () => {
    setOpenAgregarElemento(false);
    setElementoSelector("");
  };

  const agregarElemento = () => {
    let elementosAux = componentesAsociados;
    let elemento = elementosAux.filter(
      (element) =>
        element.nombreElemento.toUpperCase() === elementoSelector.toUpperCase(),
    )[0];

    if (elemento) {
      enqueueSnackbar("El elemento ya existe.", {
        variant: "error",
      });
    } else {
      elementosAux.push({
        nombreElemento: elementoSelector.toUpperCase(),
      });
      setComponentesAsociados(elementosAux);
    }

    setElementoSelector("");
    setOpenAgregarElemento(false);
  };

  const guardarPlan = async () => {
    if (
      nombreColumna === "" ||
      nombreColumna === " " ||
      tipoDato === "" ||
      tipoComponente === "" ||
      labelComponente === " " ||
      labelComponente === ""
    ) {
      enqueueSnackbar("Todos los campos son obligatorios.", {
        variant: "error",
      });
    } else {
      let nombreColumnaAux =
        nombreColumna[0].toLowerCase() + nombreColumna.slice(1);

      nombreColumnaAux = nombreColumnaAux.replace(/ /g, "");

      let elemento = columnasCliente.filter(
        (element) =>
          element.Field.toLowerCase() === nombreColumnaAux.toLowerCase(),
      )[0];
      if (elemento) {
        enqueueSnackbar(`${nombreColumnaAux} ya existe en los registros`, {
          variant: "error",
        });
      } else {
        let columna = {
          nombreColumna: nombreColumnaAux,
          tipoDato: tipoDato,
          labelComponente: labelComponente,
          tipoComponente: tipoComponente,
        };
        try {
          const respuesta = await addRelacionColumnaCliente(columna).unwrap();
          if (tipoComponente === "select") {
            const promesaSelector = componentesAsociados.map((element) =>
              addRelacionSelectorElemento({
                refComponente: respuesta,
                nombreElemento: element.nombreElemento,
              }).unwrap(),
            );

            await Promise.all(promesaSelector);
          }
          dispatch(clientesApi.util.invalidateTags(["tablaClientes"]));
          setOpen(false);
          enqueueSnackbar("Columna creada correctamente.", {
            variant: "success",
          });
        } catch {
          enqueueSnackbar("Error al crear la columna.", {
            variant: "error",
          });
        }
      }
    }
  };

  const cancelar = () => {
    setNombreColumna("");
    setTipoDato("");
    setOpen(false);
  };
  return (
    <>
      <Dialog open={open} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Nueva Columna</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Nombre Columna"
            type="text"
            value={nombreColumna}
            onChange={handleChangeNombreColumna}
            fullWidth
            required
          />

          <FormControl style={{ marginTop: "10px" }} fullWidth>
            <InputLabel>Tipo Dato (*)</InputLabel>
            <Select
              style={{ marginTop: "10px" }}
              value={tipoDato}
              onChange={handleChangeTipoDato}
            >
              <MenuItem value="">
                <em>Ninguno</em>
              </MenuItem>
              <MenuItem value="text">TEXTO</MenuItem>
              <MenuItem value="int">ENTEROS</MenuItem>
              <MenuItem value="double">DECIMALES</MenuItem>
            </Select>
          </FormControl>

          <FormControl style={{ marginTop: "10px" }} fullWidth>
            <InputLabel>Tipo Componente (*)</InputLabel>
            <Select
              style={{ marginTop: "10px" }}
              value={tipoComponente}
              onChange={handleChangeTipoComponente}
            >
              <MenuItem value="">
                <em>Ninguno</em>
              </MenuItem>
              <MenuItem value="textfield">TEXTO</MenuItem>
              <MenuItem value="select">SELECTOR</MenuItem>
            </Select>
          </FormControl>

          <TextField
            style={{ marginTop: "10px" }}
            margin="dense"
            label="Nombre del Campo"
            type="text"
            required
            value={labelComponente}
            onChange={handleChangeLabelComponente}
            fullWidth
          />

          {tipoComponente === "select" && (
            <div>
              <Button
                color="primary"
                startIcon={<Icon icon={plusFill} />}
                style={{ marginTop: "10px" }}
                onClick={handleClickOpenAgregar}
              >
                Agregar Elemento Selector
              </Button>

              <TableContainer component={Paper} style={{ marginTop: "10px" }}>
                <Table size="small" aria-label="a dense table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Nombre Elemento Selector</TableCell>
                      <TableCell align="right"></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {componentesAsociados.map((row, index) => (
                      <TableRow key={index}>
                        <TableCell component="th" scope="row">
                          {row.nombreElemento}
                        </TableCell>
                        <TableCell align="right">
                          <Button
                            onClick={() => {
                              let componentes = componentesAsociados.filter(
                                (dato) =>
                                  dato.nombreElemento !== row.nombreElemento,
                              );
                              setComponentesAsociados(componentes);
                            }}
                            color="error"
                          >
                            Eliminar
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={cancelar} color="error">
            Cancelar
          </Button>
          <Button onClick={guardarPlan} color="primary">
            Agregar
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={openAgregarElemento} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">
          Nombre Elemento Selector
        </DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Nombre Elemento Selector"
            type="text"
            value={elementoSelector}
            onChange={handleChangeNombreElementoSelector}
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseAgregar} color="error">
            Cancelar
          </Button>
          <Button onClick={agregarElemento} color="primary">
            Agregar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
